<template>
  <!-- 这可是 支付结果查询弹窗哦！！ -->
  <el-dialog :visible.sync="visiableDialog" class="order_res-dialog" width="400px" :show-close="false" center>
    <div class="order_res-dialog-title" slot="title">
      <img :src="require(`../assets/imgs/icon/pay_${orderInfo.status === 1 ? 'success' : 'fail'}.png`)" />
      {{ orderStatusText }}
    </div>
    <div class="order_res-dialog-content">
      <div class="pay_title">订单内容</div>
      <template v-for="item in orderInfoList">
        <div class="order_item" :class="{ hasTips: item.hasTips }" v-if="item.key === 'contents'" :key="item.key">
          <span class="label" :class="{ hide: !item.label }">{{ item.label }}</span>
          <div class="value-wrap">
            <span class="value">{{ item.value }}</span>
            <span class="subtitle">{{ item.subtitle }}</span>
          </div>
        </div>
        <div class="order_item" :class="{ consignee_info: item.key === 'consignee_info' }" :key="item.key" v-else>
          <span class="label" :class="{ hide: !item.label }">{{ item.label }}</span>
          <span class="value" :class="{ hide: !item.value, point: item.hasPoint }">{{ item.value }}</span>
        </div>
      </template>
      <div class="conversion_code-wrap" v-if="showConversionCode">
        <div class="conversion_code-tips">点击下方复制兑换码</div>
        <button class="conversion_code" ref="conversionCode" :data-clipboard-text="`${orderInfo.change_code}`">
          {{ orderInfo.change_code }}
        </button>
        <!-- <div class="conversion_code"></div> -->
      </div>
    </div>
    <div class="actions-bl">
      <div class="close_btn" @click="closeVisiableDialog">关闭</div>
    </div>
  </el-dialog>
  <!-- 支付结果查询弹窗END -->
</template>

<script>
import { Dialog } from 'element-ui';
import requestApi from '@/service';
import Clipboard from 'clipboard';

export default {
  components: {
    [Dialog.name]: Dialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  model: {
    prop: 'show',
  },
  data() {
    return {
      visiableDialog: false,
      orderInfo: {},
      orderInfoList: [],
    };
  },
  watch: {
    show(val) {
      this.visiableDialog = val;
      if (val) {
        this.getOrderInfo();
      } else {
        this.destroyCopy();
      }
    },
    visiableDialog(val) {
      this.$emit('input', val);
    },
  },
  computed: {
    orderStatusText() {
      const obj = {
        1: '支付成功',
        9: '等待付款',
      };
      return obj[this.orderInfo.status];
    },
    showConversionCode() {
      const info = this.orderInfo;
      return info.change_code;
    },
  },
  beforeDestroy() {
    this.destroyCopy();
  },
  methods: {
    getOrderInfo() {
      this.queryOrderStatus().then(order => {
        this.orderInfo = order;
        this.handleOrderInfo();
        if (this.showConversionCode) {
          this.initCopy();
        }
      });
    },
    /**
     * @description: 查询订单状态
     */
    queryOrderStatus(id = this.id) {
      let url;
      switch (this.type) {
        case 'vip':
          url = `/api/h5/order/wanxiang/member/${id}`;
          break;
        case 'single_class':
          url = `/api/h5/order/wanxiang/single/${id}`;
          break;
        case 'article':
        case 'article_class':
          url = `/api/h5/order/wanxiang/article/${id}`;
          break;
        case 'activity':
          url = `/api/h5/order/${id}`;
          break;
        default:
          break;
      }
      return new Promise(resolve => {
        requestApi(url).then(({ order }) => {
          resolve(order);
        });
      });
    },
    closeVisiableDialog() {
      this.visiableDialog = false;
      this.destroyCopy();
    },
    /**
     * @description: 处理订单结果页展示数据
     */
    async handleOrderInfo() {
      const orderType = this.type;
      switch (orderType) {
        case 'activity':
          this.orderInfoList = this.handleActivityOrderInfo();
          break;
        case 'single_class':
          this.orderInfoList = this.handleWanXiangOrderInfo();
          break;
        case 'article':
        case 'article_class':
          this.orderInfoList = await this.handleArticleOrderInfo(orderType);
          break;
        case 'vip':
          this.orderInfoList = this.handleVipOrderInfo();
          break;
        default:
          break;
      }
    },
    handleActivityOrderInfo() {
      const order = this.orderInfo;
      const fields = {
        order_num: '订单编号',
        real_fee: '订单金额',
        number: '购票数量',
        screenings: '演出时间',
        address: '演出地点',
      };
      const res = [];
      Object.keys(fields).forEach(key => {
        if (key === 'number') {
          const tempArr = order.screenings.map(item => {
            return `${item.name} * ${item.number}`;
          });
          res.push({
            label: '购票数量',
            value: tempArr.join(),
            key,
          });
        } else if (key === 'screenings') {
          res.push(...this.handleScreenings(order.screenings, fields[key]));
        } else if (key === 'real_fee') {
          res.push({
            label: fields[key],
            value: `${order[key]} 元`,
            key,
          });
        } else {
          res.push({
            label: fields[key],
            value: order[key],
            key,
          });
        }
      });
      res.push({
        label: '入场二维码',
        value: '请在 App/H5/小程序 中查看',
      });
      return res;
    },
    handleWanXiangOrderInfo() {
      const order = this.orderInfo;
      const fields = {
        order_num: '订单编号',
        real_fee: '订单金额',
        contents: '订单内容',
      };
      const res = [];
      Object.keys(fields).forEach(key => {
        if (key === 'contents') {
          const tempArr = [];
          order.contents.forEach((item, i) => {
            tempArr.push({
              label: fields.contents,
              value: item.title,
              key: `${encodeURI(item.title)}_${i}`,
            });
            item.extension.forEach((extension, j) => {
              tempArr.push({
                label: '',
                value: extension,
                key: `${encodeURI(extension)}_${j}`,
                hasPoint: true,
              });
            });
          });
          res.push(...tempArr);
        } else if (key === 'real_fee') {
          res.push({
            label: fields[key],
            value: `${order[key]} 元`,
            key,
          });
        } else {
          res.push({
            label: fields[key],
            value: order[key],
            key,
          });
        }
      });
      return res;
    },
    async handleArticleOrderInfo(type) {
      if (!this.consignee) {
        await this.getConsigneeInfo();
      }
      const order = this.orderInfo;
      const fields = {
        order_num: '订单编号',
        real_fee: '订单金额',
        contents: '订单内容',
      };
      const res = [];
      Object.keys(fields).forEach(key => {
        if (key === 'contents') {
          if (type == 'article_class') {
            // 实物课程
            const tempArr = [];
            order.contents.forEach((item, i) => {
              tempArr.push({
                label: fields.contents,
                value: item.title,
                key: `${encodeURI(item.title)}_${i}`,
              });
              item.extension.forEach((extension, j) => {
                tempArr.push({
                  label: '',
                  value: extension,
                  key: `${encodeURI(extension)}_${j}`,
                  hasPoint: true,
                });
              });
            });
            res.push(...tempArr);
          } else if (type === 'article') {
            // 实物
            res.push({
              label: fields.contents,
              value: this.orderItems[this.orderCheckItem].title,
              key,
            });
          }
        } else if (key === 'real_fee') {
          res.push({
            label: fields[key],
            value: `${order[key]} 元`,
            key,
          });
        } else {
          res.push({
            label: fields[key],
            value: order[key],
            key,
          });
        }
      });
      if (order.order_article_type !== 1) {
        res.push(
          {
            label: '收货人信息',
            value: `${this.consignee.name} ${this.consignee.mobile}`,
            key: 'consignee_info',
          },
          {
            label: '',
            value: this.consignee.addressStr,
            key: 'consignee_address',
          }
        );
      }
      return res;
    },
    // 因为样式变了 我们需要对这里做特殊处理
    handleVipOrderInfo() {
      const order = this.orderInfo;
      const fields = {
        order_num: '订单编号',
        real_fee: '订单金额',
        contents: '订单内容',
      };
      const res = [];
      Object.keys(fields).forEach(key => {
        if (key === 'contents') {
          // const tempArr = [];
          const temp = {
            label: fields[key],
            value: order.web_content ? order.web_content.title_1 : '',
            key,
            hasTips: true,
          };
          if (order.web_content && order.web_content.info_1 && !this.showConversionCode) {
            Object.assign(temp, {
              subtitle: order.web_content.info_1,
            });
          }
          res.push(temp);
          /* order.contents.forEach((item, i) => {
            tempArr.push({
              label: fields.contents,
              value: item.title,
              key: `${encodeURI(item.title)}_${i}`,
            });
          }); */
          // res.push(...tempArr);
        } else if (key === 'real_fee') {
          res.push({
            label: fields[key],
            value: `${order[key]} 元`,
            key,
          });
        } else {
          res.push({
            label: fields[key],
            value: order[key],
            key,
          });
        }
      });
      return res;
    },
    handleScreenings(data, label) {
      const map = {};
      for (const item of data) {
        const arr = item.start_time.split(' ');
        if (!map[arr[0]]) map[arr[0]] = [];
        map[arr[0]].push({
          date: arr[0],
          label: `${item.name} ${arr[1]} - ${item.end_time.split(' ')[1]}`,
        });
      }
      const list = [];
      Object.keys(map).forEach((date, i) => {
        list.push({
          label,
          value: date,
          key: `${date}_${i}`,
        });
        map[date].forEach((e, j) => {
          list.push({
            label: '',
            value: e.label,
            key: `${e.label}_${i}_${j}`,
          });
        });
      });
      return list;
    },
    initCopy() {
      this.$nextTick(() => {
        this.clipboard = new Clipboard(this.$refs.conversionCode);
        this.clipboard.on('success', () => {
          this.$message.success('复制成功');
        });
        this.clipboard.on('error', () => {
          // 不支持复制
          console.error('该浏览器不支持自动复制');
        });
      });
    },
    destroyCopy() {
      // 释放内存
      this.clipboard && this.clipboard.destroy();
    },
    /**
     * @description: 获取用户的收货信息
     */
    getConsigneeInfo() {
      return requestApi('/api/h5/address/').then(res => {
        this.setConsignee(res);
      });
    },
    setConsignee(data) {
      this.consignee = { ...data, addressStr: `${data.province}${data.city}${data.district} ${data.address}`, id: data.address_id };
    },
  },
};
</script>

<style lang="scss" scoped>
.order_res-dialog {
  ::v-deep.el-dialog__header {
    text-align: center;
    padding: 25px 0 5px;
  }
  ::v-deep.el-dialog__body {
    padding: 0;
    color: $C3;
  }
  .pay_title {
    font-family: HYXinRenWenSongW;
    font-size: 12px;
    padding: 15px 20px 10px;
    font-weight: bold;
  }
}
.order_res-dialog {
  &-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: HYXinRenWenSongW;
    font-size: 18px;
    & > img {
      width: 13px;
      height: 17px;
      max-width: 13px;
      margin-right: 10px;
    }
  }
  &-content {
    .order_item {
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      justify-content: space-between;
      background: $C15;
      margin-bottom: 1px;
      box-sizing: border-box;
      .hide {
        visibility: hidden;
      }
      &.hasTips {
        align-items: flex-start;
        padding-top: 15px;
      }
      .value-wrap {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .value {
          line-height: 20px;
        }
        .subtitle {
          font-size: 10px;
          color: #808080;
          line-height: 14px;
        }
      }
      &.consignee_info {
        margin-top: 10px;
      }
    }
  }
  .actions-bl {
    text-align: center;
    padding: 20px 0;
    .close_btn {
      display: inline-block;
      width: 100px;
      height: 40px;
      line-height: 40px;
      font-family: HYXinRenWenSongW;
      text-align: center;
      cursor: pointer;
      background: $C3;
      color: $C1;
      border: 1px solid $C3;
    }
  }
  .conversion_code-wrap {
    text-align: center;
    margin-top: 15px;
    .conversion_code {
      border: none;
      outline: none;
      padding: 0;
      margin: 0;
      background: transparent;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 1px;
      cursor: pointer;
      padding: 5px 10px;
    }
  }
}
</style>
